export default {
    "ember/test/k": require("./ember/chapters/test/tests/test_k.json"),
    "ember/test/l": require("./ember/chapters/test/tests/test_l.json"),
}
